import { SortPredictionMarketEnum } from "@/components/PredictionMarket/SortPredictionMarket";
import { SortSportEnum } from "@/components/homepage/SortSport";
import type { LabelData, SubLabelData } from "@/hooks/predictionMarket/usePredictionMarketLabels";
import { DEFAULT_LABELS_PREDICTION_MARKET } from "@/pages/PredictionMarket/constant";
import { LEAGUES, type League, SPORTS, type Sport, TABS, type Tab } from "@/pages/Tournaments/constant";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
export interface IHomePageStore {
  selectedLeague: League;
  setSelectedLeague: (league: League) => void;
  selectedTab: Tab;
  setSelectedTab: (tab: Tab) => void;
  selectedSortType: SortSportEnum;
  setSelectedSortType: (sortType: SortSportEnum) => void;
  selectedSport: Sport;
  setSelectedSport: (sport: Sport) => void;

  isOpenMyPageSidebar: boolean;
  setIsOpenMyPageSidebar: (isOpen: boolean) => void;

  selectedLabel: LabelData;
  setSelectedLabel: (label: LabelData) => void;
  selectedSubLabel: SubLabelData;
  setSelectedSubLabel: (label: SubLabelData) => void;
  selectedSortPredictionMarketType: SortPredictionMarketEnum;
  setSelectedSortPredictionMarketType: (sortType: SortPredictionMarketEnum) => void;
}

export const useHomePageStore = create<IHomePageStore>((set) => ({
  selectedLeague: LEAGUES[0],
  selectedSortType: SortSportEnum.EARLIEST_EVENT_DATE,
  selectedSport: SPORTS[0],
  isOpenMyPageSidebar: false,
  selectedTab: TABS[0],
  selectedLabel: DEFAULT_LABELS_PREDICTION_MARKET[0],
  selectedSubLabel: { id: "人気-すべて", label: "すべて" },
  selectedSortPredictionMarketType: SortPredictionMarketEnum.Recommended,

  setSelectedLeague: (league: League) => set({ selectedLeague: league }),
  setSelectedSport: (sport: Sport) => set({ selectedSport: sport }),
  setSelectedSortType: (sortType: SortSportEnum) => set({ selectedSortType: sortType }),
  setSelectedTab: (tab: Tab) => set({ selectedTab: tab }),
  setIsOpenMyPageSidebar: (isOpen: boolean) => set({ isOpenMyPageSidebar: isOpen }),
  setSelectedLabel: (label: LabelData) => set({ selectedLabel: label }),
  setSelectedSubLabel: (label: SubLabelData) => set({ selectedSubLabel: label }),
  setSelectedSortPredictionMarketType: (sortType: SortPredictionMarketEnum) =>
    set({ selectedSortPredictionMarketType: sortType }),
}));

interface ISkipPrizesStore {
  skipPrizes: boolean;
  setSkipPrizes: (skip: boolean) => void;
}

export const useSkipPrizesStore = create<ISkipPrizesStore>()(
  persist(
    (set) => ({
      skipPrizes: false,
      setSkipPrizes: (skip: boolean) => set({ skipPrizes: skip }),
    }),
    {
      name: "skip-prizes-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export interface IFirstVisitStore {
  isFirstVisit: boolean;
  setIsFirstVisit: (isFirstVisit: boolean) => void;
  hasVisitedPMVersion: boolean;
  setHasVisitedPMVersion: (visited: boolean) => void;
}

// This store is intentionally in-memory only (not persisted to localStorage)
// so that isFirstVisit resets to true when the page is refreshed
export const useFirstVisitStore = create<IFirstVisitStore>()(
  persist(
    (set) => ({
      isFirstVisit: true,
      setIsFirstVisit: (isFirstVisit: boolean) => set({ isFirstVisit }),
      hasVisitedPMVersion: false,
      setHasVisitedPMVersion: (visited: boolean) => set({ hasVisitedPMVersion: visited }),
    }),
    {
      name: "first-visit-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

interface IDisplayLegalNotice {
  showLegalNotice: boolean;
  isPreventedNotice: boolean;
  lastLegalNoticeDisplayTime: number | null;
  setShowLegalNotice: (hide: boolean) => void;
  setLastLegalNoticeDisplayTime: (time: number) => void;
  setIsPreventedNotice: (isPrevented: boolean) => void;
}

export const useDisplayLegalNotice = create<IDisplayLegalNotice>()(
  persist(
    (set) => ({
      showLegalNotice: true,
      isPreventedNotice: false,
      lastLegalNoticeDisplayTime: null,
      setShowLegalNotice: (hide: boolean) => set({ showLegalNotice: hide }),
      setLastLegalNoticeDisplayTime: (time: number) => set({ lastLegalNoticeDisplayTime: time }),
      setIsPreventedNotice: (isPrevented: boolean) => set({ isPreventedNotice: isPrevented }),
    }),
    {
      name: "display-legal-notice",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
